import { render, staticRenderFns } from "./ChannelAbility.vue?vue&type=template&id=ade89748&scoped=true&"
import script from "./ChannelAbility.vue?vue&type=script&lang=js&"
export * from "./ChannelAbility.vue?vue&type=script&lang=js&"
import style0 from "./ChannelAbility.vue?vue&type=style&index=0&id=ade89748&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade89748",
  null
  
)

export default component.exports